<template>
  <div class="dashboard-editor-container">
    <el-row :gutter="20">
      <!-- 所有设备 -->
      <el-col :xs="8" :sm="8" :lg="8">
        <div class="card_box">
          <p class="section_tit" @click="goToAllDevice">
            {{ $t("dashboard.AllDevices") }}
            <span style="margin-left: 10px;">{{ machineNum }}</span>
          </p>
          <pie-chart :series-data="pieSeriesData" :machine-num="machineNum" />
        </div>
      </el-col>
      <el-col :xs="8" :sm="8" :lg="8">
        <!-- 近15天联网率  -->
        <div class="card_box">
          <p class="section_tit">{{ $t('AllDevices.connectivityHealth') }}
            <el-popover placement="top-start" title="" width="200" trigger="hover"
              :content="$t('AllDevices.connectivityHealthInfo')">
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>
          </p>

          <lineChartTwo :line-date="lineDate" />
        </div>
      </el-col>
      <el-col :xs="8" :sm="8" :lg="8">
        <div class="card_box">
          <!-- 异常设备 -->
          <p class="section_tit" @click="goToWarningPage"> {{ $t("dashboard.Abnormal") }}
            <span style="margin-left: 10px;">{{ abnormalNum }}</span>
          </p>
          <bar-chart :series-data="barSeriesData" :height="pieHeight" />
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20" v-if="!isGuest">
      <el-col :xs="12" :sm="12" :lg="12">
        <!-- 地区统计 -->
        <div class="section_box">
          <span class="section_tit" @click="goToWarningPage">{{ $t("dashboard.SiteView") }}</span>
          <el-table :data="siteTableData" class="table_box">
            <el-table-column prop="site" :label="$t('dashboard.SiteName')" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-link type="primary" @click="goToDevicePage(scope.row.site,'site')">
                  {{ scope.row.site? scope.row.site:$t('dashboard.Undefined') }}
                </el-link>
              </template>
            </el-table-column>
            <el-table-column prop="totalDeviceCount" :label="$t('dashboard.TotalDevices')" align="center" />
            <el-table-column prop="warningDeviceCount" :label="$t('dashboard.TotalWarnDevice')" align="center">
              <template slot-scope="scope">
                <el-link type="primary" @click="goToWarnPage(scope.row.site,'site')">
                  {{ scope.row. warningDeviceCount }}
                </el-link>
              </template>
            </el-table-column>
          </el-table>
          <!-- 列表模块————分页 -->
          <div class="flex_center" style="margin-top: 10px;">
            <el-pagination v-if="pageshow1" :page-size="listQuery1.pageInfo.limit"
              :page-sizes="listQuery1.pageInfo.pageList" :total="listQuery1.pageInfo.total" background
              current-page.sync="listQuery1.pageInfo.page" layout="total, prev, pager, next"
              @current-change="handleCurrentChange1" @size-change="handleSizeChange1" />
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="12">
        <!-- 归属公司设备统计 -->
        <div class="section_box">
          <span class="section_tit" @click="goToWarningPage">{{ $t("dashboard.OwnerView") }}</span>
          <el-table :data="owerCompanyTableData" class="table_box">
            <el-table-column prop="companyName" :label="$t('BondOrUpdateDevice.OwnedCompany')" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-link type="primary" @click="goToDevicePage(scope.row.companyId,'companyId')">
                  {{ scope.row. companyName }}
                </el-link>
              </template>
            </el-table-column>
            <el-table-column prop="totalDeviceCount" :label="$t('dashboard.TotalDevices')" align="center" />
            <el-table-column prop="warningDeviceCount" :label="$t('dashboard.TotalWarnDevice')" align="center">
              <template slot-scope="scope">
                <el-link type="primary" @click="goToWarnPage(scope.row.companyId,'companyId')">
                  {{ scope.row. warningDeviceCount }}
                </el-link>
              </template>
            </el-table-column>
          </el-table>
          <!-- 列表模块————分页 -->
          <div class="flex_center" style="margin-top: 10px;">
            <el-pagination v-if="pageshow2" :page-size="listQuery2.pageInfo.limit"
              :page-sizes="listQuery2.pageInfo.pageList" :total="listQuery2.pageInfo.total" background
              current-page.sync="listQuery2.pageInfo.page" layout="total, prev, pager, next"
              @current-change="handleCurrentChange2" @size-change="handleSizeChange2" />
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 异常警告统计 -->
    <div class="section_box">
      <span class="section_tit" style="width:auto" @click="goToWarningPage"> {{ $t("dashboard.RecentNotices") }}
      </span>
      <el-button type="primary" icon="el-icon-view" @click="goToWarningPage" />
      <div class="table_box">
        <el-table :data="tableData">
          <el-table-column prop="updateTime" :label="$t('dashboard.LatestUpdate')" />
          <el-table-column prop="deviceName" :label="$t('dashboard.DeviceName')">
            <template slot-scope="scope">
              <el-link type="primary" @click="goToDetailgPage(scope.row)">
                {{ scope.row. deviceName }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column :label="$t('dashboard.Details')" prop="message">
            <template slot-scope="scope">
              <p style="text-align: left;">
                {{ scope.row.message }}
                <span v-if="scope.row.msgType==4" style="color:red;">{{ $t('warningInfo.LevelWarn1') }}</span>
                <span v-else-if="scope.row.msgType==11" style="color:red;">{{ $t('warningInfo.LevelWarn2') }}</span>
                <span v-else-if="scope.row.msgType==12" style="color:red;">{{ $t('warningInfo.LevelWarn3') }}</span>
                <span v-else-if="scope.row.msgType==13" style="color:red;">{{ $t('warningInfo.LevelWarn4') }}</span>
              </p>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { findCompanyDeviceStatistic, listWarningByCompany, findDeviceInfo, deviceOnlineStatistic, mainSiteWarningStatisticData, mainCompanyWarningStatisticData } from '@/api/dashboard'
import { howLongAgo, getDateAndHour } from '@/utils/updateTime.js'
import { temChangeUnit } from '@/utils/temChange.js'

import PieChart from '@/components/pieChart'
import BarChart from '@/components/barChart'
import lineChartTwo from '@/components/lineChartTwo'

import { pagination } from '@/utils/init_table' // 分页

export default {
  name: 'DashboardAdmin',
  components: {
    PieChart,
    BarChart,
    lineChartTwo
  },
  data () {
    return {
      // 分页1----start
      listQuery1: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow1: true,
      // 分页1----end
      // 分页2----start
      listQuery2: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow2: true,
      // 分页----end
      lineDate: [],
      lineHeight: '400px',
      machineNum: 0,
      abnormalNum: 0,
      warningNum: 0,
      nowTime: getDateAndHour(new Date()),
      pieSeriesData: [],
      barYAxisData: [],
      barSeriesData: [],
      tableData: [],
      pieHeight: '400px',
      interval: null,
      nameTableData: [{ sName: 'Y-HUB', allName: 'BATTERY MONITOR' },
      { sName: 'MACHINE(HSM)', allName: 'MECHANICAL INFORMATION(HSM)' },
      { sName: 'INVERTER', allName: 'BI-DIRECTIONAL INVERTER CHARGER' },
      { sName: 'BATTERY(GPD)', allName: 'LITHIUM BATTERY(GPD)' },
      { sName: 'SYSTEM(GPD)', allName: 'TOTAL SYSTEM(GPD)' }
      ],
      isShowPop: false,
      siteTableData: [],
      owerCompanyTableData: []
    }
  },
  computed: {
    language () {
      return this.$store.state.language
    },
    isGuest () {
      return this.$store.state.userInfo.guestFlag
    }
  },
  watch: {
    language (newValue, oldValue) {
      this.queryList()
      this.initLineChart()
    }
  },
  mounted () {
    this.queryList()
    this.setTimerCharger()
    this.initLineChart()
    this.getSiteWarn()
    this.getCompanyWarn()
  },
  created () {
    console.log('home')
    // 每次进入界面时，先清除之前的所有定时器，然后启动新的定时器
    clearInterval(this.interval)
    this.interval = null
  },
  destroyed () {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.interval)
    this.interval = null
  },
  methods: {

    queryList () {
      var param = {
        // 'companyId': this.$store.state.company ? this.$store.state.company.id : '',
        companyIdList: []
      }
      // if (this.$store.state.company)param.companyIdList.push(this.$store.state.company.id)
      // 设备总数量、当前异常数、设备类型占比
      findCompanyDeviceStatistic(param).then(response => {
        this.machineNum = response.resultModel.totalDevice
        this.abnormalNum = response.resultModel.warningDevice
        // 设备类型占比--饼状图
        // deviceFunction(response.resultModel.deviceStatistic)
        this.barSeriesData = []
        this.pieSeriesData = []
        response.resultModel.deviceStatistic.forEach(v => {
          this.pieSeriesData.push({
            value: v.deviceCount,
            name: v.deviceTypeName
          })
          // 当前异常--柱状图
          this.barSeriesData.push({
            value: v.warningCount,
            name: v.deviceTypeName,
            total: v.deviceCount
          })
        })
      })
      // 获取前10条警告信息
      listWarningByCompany(param).then(response => {
        console.log('警告查询', response)
        this.tableData = response.resultModel || []
        this.warningNum = this.tableData.length
        // return
        for (var i = this.tableData.length - 1; i >= 0; i--) {
          var v = this.tableData[i]
          v.updateTime = howLongAgo(v.createTime)
          if (v.msgType == 1) {
            if (v.triggerValue) {
              v.triggerValue = v.triggerValue > 100 ? Math.round(v.triggerValue / 100) : Math.round(v.triggerValue)
            }
            v.message = this.$t('warningInfo.batterySocLow1') + v.triggerValue + this.$t(`warningInfo.batterySocLow2`)
          } else if (v.msgType == 2) {
            v.message = this.$t('warningInfo.batteryWaterLow')
          } else if (v.msgType == 4 || v.msgType == 11 | v.msgType == 12 || v.msgType == 13) {
            if (v.triggerValue) {
              v.triggerValue = v.triggerValue > 1000 ? Math.round(v.triggerValue / 100) : Math.round(v.triggerValue)
            }
            v.message = this.$t('warningInfo.batteryTemHeight1') + temChangeUnit(v.triggerValue) + this.$t('warningInfo.batteryTemHeight2')
          } else if (v.msgType == 5) {
            v.message = this.$t('warningInfo.batteryCapacity1') + v.triggerValue + this.$t('warningInfo.batteryCapacity2')
          } else if (v.msgType == 6) {
            v.message = this.$t('warningInfo.batteryNoPosition')
          } else if (v.msgType == 7) {
            v.message = this.$t('warningInfo.batteryVoltageLow1') + v.triggerValue + this.$t('warningInfo.batteryVoltageLow2')
          } else if (v.msgType == 8) {
            v.message = this.$t('warningInfo.batteryTemLow1') + temChangeUnit(v.triggerValue) + this.$t('warningInfo.batteryTemLow2')
          } else if (v.msgType == 9) {
            v.message = this.$t('warningInfo.batteryTemAbnormal')
          } else if (v.msgType == 10) {
            v.message = this.$t('warningInfo.batteryVoltageHeight1') + v.triggerValue + this.$t('warningInfo.batteryVoltageHeight2')
          } else if (v.msgType == 15) {
            v.message = this.$t('warningInfo.HalfVWarn')
          } else if (v.msgType == 16) {
            v.message = this.$t('warningInfo.offlineWarn').replace('$1', v.triggerValue)
          } else if (v.msgType == 17) {
            v.message = this.$t('warningInfo.linChargeOverWarn')
          } else if (v.msgType == 18) {
            if (v.triggerValue) { v.triggerValueZh = getDateAndHour(v.triggerValue, 'noTime') }
            v.message = this.$t('warningInfo.overTiemTo').replace('$1', v.triggerValueZh)
          } else if (v.msgType == 19) {
            v.message = this.$t('warningInfo.overTiem')
          } else if (v.msgType == 20) {
            v.message = this.$t('warningSet.chargeDisAbnormalWarn')
          } else if (v.msgType == 21) {
            v.message = this.$t('warningInfo.unitVLowWarn')
          } else {
            // v.message = v.msgType
            this.tableData.splice(i, 1)
          }
        }
      })
    },
    getSiteWarn () { // 获取城市警告等数据
      var param = {
        pageNum: this.listQuery1.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery1.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      mainSiteWarningStatisticData(param).then(res => {
        if (res.resultCode != 1001 || !res.resultModel) return
        this.siteTableData = res.resultModel.list || []
        this.listQuery1.pageInfo.total = res.resultModel.total // 分页
      })
    },
    getCompanyWarn () { // 获取公司警告等数据
      var param = {
        pageNum: this.listQuery2.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery2.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      mainCompanyWarningStatisticData(param).then(res => {
        if (res.resultCode != 1001 || !res.resultModel) return
        this.owerCompanyTableData = res.resultModel.list || []
        this.listQuery2.pageInfo.total = res.resultModel.total // 分页
      })
    },
    goToDevicePage (val, attr) { // 去设备列表页
      var query = {}
      query[attr] = val
      const routeData = this.$router.resolve({
        path: '/allDevices/allDeviceIndex',
        query
      })
      window.open(routeData.href, '_self')
    },
    goToWarnPage (val, attr) { // 去警告页
      var query = {}
      query[attr] = val
      const routeData = this.$router.resolve({
        path: '/warning/warningIndex',
        query
      })
      window.open(routeData.href, '_self')
    },
    initLineChart () { // 设备联网率
      const param = {
        companyIdList: [],
        endDate: new Date().setHours(0, 0, 0, 0),
        startDate: new Date().setHours(0, 0, 0, 0) - 15 * 24 * 60 * 60 * 1000
      }
      deviceOnlineStatistic(param).then(res => {
        // console.log(res)
        if (res.resultCode == 1001) {
          this.lineDate = res.resultModel
        }
      })
    },
    goToAllDevice () {
      const routeData = this.$router.resolve({
        path: 'allDevices/allDeviceIndex',
        query: this.$route.query
      })
      window.open(routeData.href, '_self')
    },
    goToWarningPage () {
      const routeData = this.$router.resolve({
        path: 'warning/warningIndex',
        query: this.$route.query
      })
      window.open(routeData.href, '_self')
    },
    goToDetailgPage (row) {
      findDeviceInfo({ mcuId: row.mcuId }).then(res => {
        var myRow = res.resultModel
        const routeData = this.$router.resolve({
          path: '/allDevices/allDeviceDetail',
          query: {
            mcuId: row.mcuId,
            deviceType: myRow.deviceType,
            sn: myRow.deviceSn,
            id: myRow.id
            // mcuId: '05d9ff333432554e43133650'
          }
        })
        window.open(routeData.href, '_self')
      })
    },
    setTimerCharger () { // 定时器
      if (this.interval == null) {
        this.interval = setInterval(() => {
          this.nowTime = getDateAndHour(new Date().getTime())
        }, 1000)
      }
    },
    // 分页----start
    handleSizeChange1 (val, e) {
      // 每一页的列表的行数 10 20 50
      this.listQuery1.pageInfo.pageSize = val
      this.getSiteWarn()
    },
    handleCurrentChange1 (val, e) {
      // 选中某一页
      this.listQuery1.pageInfo.pageNum = val
      this.getSiteWarn()
    },
    // 分页----end
    // 分页----start
    handleSizeChange2 (val, e) {
      // 每一页的列表的行数 10 20 50
      this.listQuery2.pageInfo.pageSize = val
      this.getCompanyWarn()
    },
    handleCurrentChange2 (val, e) {
      // 选中某一页
      this.listQuery2.pageInfo.pageNum = val
      this.getCompanyWarn()
    }
    // 分页----end
  }
}
function deviceFunction (arr) { // 将传过来的deviceFunction进行编译
  arr.forEach(v => {
    switch (v.deviceFunction) {
      case 0: v.deviceType = 'Y-HUB'; break
      case 1: v.deviceType = 'CHARGER'; break
      case 2: v.deviceType = 'TRIONIC'; break
      case 3: v.deviceType = 'HSM'; break
      case 4: v.deviceType = 'INVERTER'; break
      case 5: v.deviceType = 'BATTERY(GPD)'; break
      case 6: v.deviceType = 'SYSTEM(GPD)'; break
      case 7: v.deviceType = 'Y-HUB'; break
    }
  })
  return arr
}
</script>

<style lang="scss" scoped>
.headContentQuestion {
  font-size: 20px;
  color: #a5a5a5;
  display: inline-block;
  vertical-align: top;
  margin: 10px 0 0 -5px;
  cursor: pointer;
}
.questionPop {
  background: white;
  padding: 14px;
  vertical-align: top;
  box-shadow: 1px 1px 5px #ccc;
  position: absolute;
  z-index: 999;
  top: 50px;
  left: 30px;
  max-width: calc(100% - 60px);
}

.section_box {
  margin-top: 20px;
  background-color: #fff;
  padding: 20px 0;
}
.section_tit {
  padding: 20px;
  color: #858585;
  font-weight: bold;
  padding-bottom: 0;
}
.table_box {
  padding: 0 20px;
}
.card_box {
  background-color: #fff;
  position: relative;
  height: 320px;
}
</style>
